import React, { useState } from "react";
import { Card, Form, InputGroup, ListGroup } from "react-bootstrap";

const Glossary = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const glossaryTerms = [
    {
      term: "Autolyse",
      definition:
        "A rest period after mixing flour and water, before adding salt and starter, allowing for better flour hydration and gluten development.",
    },
    {
      term: "Bulk Fermentation",
      definition:
        "The first fermentation period after mixing all ingredients, where the dough develops strength and flavor.",
    },
    {
      term: "Crumb",
      definition:
        "The interior texture of the bread, including the pattern of holes (also called alveoli).",
    },
    {
      term: "Hydration",
      definition:
        "The ratio of water to flour in a dough, expressed as a percentage. Higher hydration leads to more open crumb.",
    },
    {
      term: "Levain",
      definition:
        "A portion of mature sourdough starter mixed with flour and water, used to leaven bread.",
    },
    {
      term: "Proofing",
      definition:
        "The final fermentation period after shaping, where the dough develops its final structure before baking.",
    },
    {
      term: "Scoring",
      definition:
        "Cutting pattern(s) into the dough's surface before baking to control how it expands in the oven.",
    },
    {
      term: "Starter",
      definition:
        "A culture of wild yeast and bacteria maintained through regular feedings of flour and water.",
    },
    {
      term: "Stretch and Fold",
      definition:
        "A gentle dough strengthening technique where the dough is stretched and folded over itself during bulk fermentation.",
    },
    {
      term: "Tension",
      definition:
        "The surface tightness of shaped dough, crucial for proper oven spring and final loaf shape.",
    },
    {
      term: "Oven Spring",
      definition:
        "The rapid rise of bread during the first few minutes of baking due to heat expansion and final yeast activity.",
    },
    {
      term: "Banneton",
      definition:
        "A basket used for proofing bread, typically made of coiled cane or wood pulp, that helps maintain the dough's shape.",
    },
  ];

  const filteredTerms = glossaryTerms
    .filter(
      (item) =>
        item.term.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.definition.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => a.term.localeCompare(b.term));

  return (
    <Card className="mb-4">
      <Card.Header>
        <h4>Bread-Making Glossary</h4>
        <InputGroup className="mt-3">
          <Form.Control
            placeholder="Search terms or definitions..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </InputGroup>
      </Card.Header>
      <Card.Body>
        <ListGroup variant="flush">
          {filteredTerms.map((item, index) => (
            <ListGroup.Item key={index}>
              <strong>{item.term}</strong>
              <p className="mb-0 mt-1">{item.definition}</p>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Card.Body>
    </Card>
  );
};

export default Glossary;
